import { DietaryPreference } from 'apis/restaurant-api/merchant-admin/menu2/types';

export const PRODUCT_INFO_FIELD_MAX_LENGTH = 2000;

export const PRODUCT_INFO_EXTENDED_FIELD_MAX_LENGTH = 32000;

export const MORE_INFORMATION_FIELD_MAX_LENGTH = 5000;

export const INGREDIENTS_FIELD_MAX_LENGTH = 4000;

export const MENU_MOBILE_BREAKPOINT = 550;

// This ID is hard-coded in restaurant-api. Every menu automatically has this
// category. We use this in the client to hide features from regular items that
// are meant to be used with specials only.
export const WOLT_SPECIALS_CATEGORY_ID = '000000000000000000000002';

export const dietaryPreferenceTranslationMap: Record<DietaryPreference, string> = {
  'gluten-free': 'menu.dietaryPreferences.glutenFree',
  'lactose-free': 'menu.dietaryPreferences.lactoseFree',
  halal: 'menu.dietaryPreferences.halal',
  kosher: 'menu.dietaryPreferences.kosher',
  vegan: 'menu.dietaryPreferences.vegan',
  vegetarian: 'menu.dietaryPreferences.vegetarian',
};

export const ITEM_MAX_IMAGE_COUNT = 5;
